import React from 'react'
import { boolAttr } from '@fs/zion-frontend-friends'
import { css } from '@emotion/core'
import useIsMobile from '../hooks/useIsMobile'

const mainStageSectionCss = css`
  display: grid;
  grid-template-columns: 0.9fr 1.1fr;
  grid-column-gap: 24px;
  width: 100%;

  &[is-mobile] {
    grid-template-columns: 1fr;
  }
`
const videoWrapperCss = css`
  box-shadow: 0px 0px 48px rgba(0, 0, 0, 0.75);
  height: fit-content;
  display: flex; // get rid of native div extra spacing
  [is-mobile] & {
    grid-row: 1;
  }
  &[no-shadow] {
    box-shadow: none;
  }
`

const childrenWrapperCss = css`
  padding-right: 40px;
  [is-mobile] & {
    padding-right: 0;
  }
`

export default function DesktopHeaderWithVideo({ children, video, noShadow }) {
  const isMobile = useIsMobile()
  return (
    <div css={mainStageSectionCss} is-mobile={boolAttr(isMobile)}>
      <div css={childrenWrapperCss} is-mobile={boolAttr(isMobile)}>
        {children}
      </div>
      {video && (
        <div css={videoWrapperCss} no-shadow={boolAttr(noShadow)}>
          {video}
        </div>
      )}
    </div>
  )
}
